import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
            联系投稿
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12">
            {contactData.desc}
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5 mb-8">
            <div className="flex flex-col items-center gap-3 p-5 rounded-xl bg-background-50 border border-background-200">
              <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center">
                <i className="ri-mail-line text-primary-600 text-xl"></i>
              </div>
              <span className="text-xs text-foreground-500">电子邮箱</span>
              <span className="text-sm font-medium text-foreground-800">{contactData.email}</span>
            </div>
            <div className="flex flex-col items-center gap-3 p-5 rounded-xl bg-background-50 border border-background-200">
              <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center">
                <i className="ri-wechat-line text-accent-600 text-xl"></i>
              </div>
              <span className="text-xs text-foreground-500">微信公众号</span>
              <span className="text-sm font-medium text-foreground-800">{contactData.wechat}</span>
            </div>
            <div className="flex flex-col items-center gap-3 p-5 rounded-xl bg-background-50 border border-background-200">
              <div className="w-12 h-12 rounded-full bg-secondary-100 flex items-center justify-center">
                <i className="ri-qq-line text-secondary-600 text-xl"></i>
              </div>
              <span className="text-xs text-foreground-500">QQ群</span>
              <span className="text-sm font-medium text-foreground-800">{contactData.qq}</span>
            </div>
          </div>
          <div className="bg-background-50 rounded-xl border border-background-200 p-5 md:p-6">
            <h3 className="text-sm font-medium text-foreground-800 mb-3">投稿与合作须知：</h3>
            <ul className="space-y-2">
              {contactData.tips.map((tip, idx) => (
                <li key={idx} className="flex items-start gap-2.5 text-sm text-foreground-600">
                  <i className="ri-arrow-right-s-line text-primary-500 mt-0.5 flex-shrink-0"></i>
                  {tip}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}